import React, { lazy, Suspense } from 'react'
import { createBrowserRouter } from 'react-router-dom'

import Root from './Root'

// import ProtectRoute from './ProtectRoute'
// import { LoadingComponent } from '../components/common/Loading'

/* eslint-disable */
const Home = lazy(() => import('../pages/home'))
/* eslint-enable */
const AppRoutes = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    children: [
      {
        path: '/',
        element: (
          <Suspense >
            <Home />
          </Suspense>
        )
      },
      {
        path: '/index.html',
        element: (
          <Suspense >
            <Home />
          </Suspense>
        )
      }
    ]
  },
  {
    path: '/*',
    element: <p >404</p>
  }
])
export default AppRoutes